import React, { useState, useEffect } from "react"
import axios from "axios"
import "./supportedChains.scss"
import { supportChainsFetchUrl } from "../../constants"

export default function SupportedChains() {
  const [chainList, setChainList] = useState([])
  const [tokensList, seTokensList] = useState([])

  useEffect(() => {
    axios({
      method: "get",
      url: supportChainsFetchUrl,
    })
      .then(res => {
        const chains = res?.data?.chains || []
        const chainsInfo = chains.map(chain => {
          return chain.icon
        })
        setChainList(chainsInfo)
        const chain_token = res?.data?.chain_token || {}
        const tokenMap = new Map()
        Object.keys(chain_token).forEach(key => {
          const tokens = chain_token[key]?.token || []
          tokens.forEach(token => {
            if (!tokenMap.has(token?.token?.symbol)) {
              tokenMap.set(token?.token?.symbol, {
                symbol: token?.token?.symbol,
                icon: token?.icon,
              })
            }
          })
        })
        const tokensObjList = Array.from(tokenMap).map(item => item[1])
        seTokensList(tokensObjList)
      })
      .catch(e => {
        console.log(e)
      })
  }, [])

  const renderChainsSupported = () => {
    if (chainList.length === 0) {
      return null
    }
    return (
      <>
        <div className="supportedChains">
          <div className="supportedChains-title">
            {chainList.length} Chains Supported
          </div>
          <div className="supportedChains-content">
            {chainList.map(chain => {
              return <img src={chain} alt="" />
            })}
          </div>
        </div>
      </>
    )
  }

  const renderTokensSupported = () => {
    if (tokensList.length === 0) {
      return null
    }
    return (
      <>
        <div className="supportedChains">
          <div className="supportedChains-title">
            {tokensList.length} Tokens Supported
          </div>
          <div className="supportedChains-content">
            {tokensList.map(token => {
              return <img key={token.symbol} src={token.icon} alt="" />
            })}
          </div>
        </div>
      </>
    )
  }

  return (
    <div className="supportedChainsAndTokens">
      {renderChainsSupported()}
      {renderTokensSupported()}
    </div>
  )
}
